import React from "react";
import AddIcon from "../UIComponents/AddIcon";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ClientManagementCard from "./ClientManagementCard";
import { getClientManagementList, getClientUserList } from "../Actions/ClientManagementAPI";

class ClientManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchData: {
                Name: '',
                PageNumber: 1,
                PageSize: 25
            }
        }
        this.SearchData = this.SearchData.bind(this);
        this.ClearInput = this.ClearInput.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        this.props.dispatch({ type: 'SubBannerTitle', data: "Client Management" });
        this.props.dispatch(getClientManagementList(this.state.searchData));
    }

    SearchData(Pgno) {
        const { dispatch } = this.props;
        this.state.searchData.PageNumber = Pgno;
        dispatch(getClientManagementList(this.state.searchData));
    }

    ClearInput() {
        this.state.searchData.Name = "";
        this.props.dispatch(getClientManagementList(this.state.searchData));
        this.setState({});
    }

    eyeclick(item) {
        const { dispatch, history } = this.props;
        dispatch({ type: "ShowSidePan", data: true });
        dispatch({ type: "ClientDetails", data: item });
        history.push(`/Home/Management/Client/${item.clientId}`);
        dispatch(getClientUserList(item.clientId));
        window.scrollTo(0, 0);
    }

    NewitemNav = () => {
        this.props.history.push("/Home/Management/ClientAdd");
        this.props.dispatch({ type: "GetFleetManagerlist", data: null });
        this.props.dispatch({ type: "GetTechSuperintendentlist", data: null });
        this.props.dispatch({ type: "GetTechExecutivelist", data: null });
    };

    handleInputChange(e) {
        this.state.searchData.Name = e.target.value;
        if (e.target.value === "") {
            this.props.dispatch(getClientManagementList(this.state.searchData));
        }
        this.setState({});
    }

    hideSidePanel = () => {
        this.props.history.goBack();
        this.props.dispatch({ type: "ShowSidePan", data: false });
    }

    render() {
        const { ClientList, showSidePane } = this.props;
        return (
            <div className="full-height">
                <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue mt-3"
                    onClick={() => this.hideSidePanel()}
                >
                    &larr; Back
                        </button>
                <div className="pt-3">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="panel-box">
                                        <div className="card MM-card-header mb-0" style={{ backgroundColor: "white" }}>
                                            <div className="card-body flex" style={{ padding: "0rem", backgroundColor: "#1E3A8A", color: "white" }}>
                                                <h5 className="card-title m-2 " style={{ color: "092a51" }}>Client Management</h5>
                                                <div className="m-1 flex" onClick={this.NewitemNav}>
                                                    <span className="card-title m-auto">Add</span><AddIcon />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="search-filter-box">
                                            <div className="row pb-3">
                                                <div className={showSidePane ? "col-lg-6 " : "col-lg-6 "}>
                                                    <label className="form-label" >Company Name</label><br></br>
                                                    <input className="form-control" type="text" name="Name" placeholder="Company Name" value={this.state.searchData.Name} onChange={e => this.handleInputChange(e)}></input>
                                                </div>
                                                <div className={showSidePane ? "col-lg-6 pt-3" : "col-lg-6 pt-3"}>
                                                    <br></br>
                                                    <div className="search-btn-col" style={{ textAlign: "end" }}>
                                                        <button
                                                            className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                                            type="submit" onClick={() => this.SearchData(1)}>
                                                            {" "}Search  {" "}
                                                        </button>
                                                        <button
                                                            className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                                            type="button" onClick={() => this.ClearInput()}>
                                                            {" "} Clear{" "}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {ClientList ?
                                <ClientManagementCard
                                    arraylist={ClientList.data}
                                    pageSize={ClientList.pagination.pageSize}
                                    currentPage={ClientList.pagination.currentPage}
                                    totalRecords={ClientList.pagination.totalcount ? ClientList.pagination.totalcount : 0}
                                    setUpdatedState={(value) => this.SearchData(value)}
                                    eyeclick={(item) => this.eyeclick(item)}
                                />
                                : ''}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    openEditScreen() {
        this.props.dispatch({ type: "ShowSidePan", data: false });
        this.props.history.push("/Home/EditClient");
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    }
}
function mapStateToProps(state) {
    return {
        showSidePane: state.SidePanReducer.sidePan || false,
        ClientList: state.MasterScreenReducer.ClientList
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ClientManagement));